import {connect} from "react-redux";
import ViewUCDLead from "./View";
import {bindActionCreators} from "redux";
import {getLeadById} from "../../../../../service/Lead/action";

const mapStateToProps = (state) => ({
    leadById:state.Lead.leadById,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getLeadById,
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ViewUCDLead);
